import moment from 'moment';
import { dateFormats } from '@/config/Time';

class TimeHelper {

  static parse(str) {
    return moment(str).format(dateFormats.default);
  }


  static toSeconds(timestamp) {
    return timestamp / 1000
  }

  static formatDate(timestamp) {
    return moment.unix(timestamp).format(dateFormats.default);
  }

  static formatDateTime(timestamp) {
    const momentTime = moment.unix(timestamp).utc(); //Force UTC
    return momentTime.format('YYYY-MMM-DD hh:mm A [UTC]');
  }
  
  static timestampFromDaysAgo(days) {
    return moment()
      .subtract(days, 'days')
      .unix();
  }
}

export { TimeHelper };
